// Oct 31: shown when a Google or Apple sign-in would create a new account. Unchecked by default;
// the server refuses the new account until this is confirmed.
import React, { useState } from 'react';

export const needsAgeConfirmation = (err) =>
  err?.response?.status === 403 && err?.response?.data?.detail?.code === 'age_confirmation_required';

export const SocialAgeConfirm = ({ provider, lang, onContinue, onCancel }) => {
  const [checked, setChecked] = useState(false);
  const es = lang === 'es';
  return (
    <div data-testid={`social-age-confirm-${provider}`} className="w-full rounded-xl p-4"
      style={{ border: '1px solid rgba(230,192,110,0.35)', backgroundColor: 'rgba(255,255,255,0.03)' }}>
      <p className="text-sm mb-3" style={{ color: 'rgba(255,255,255,0.85)' }}>
        {es ? 'Para crear tu cuenta, confirma que tienes 18 años o más.'
          : 'To create your account, please confirm you are 18 or older.'}
      </p>
      <label className="flex items-start gap-2 text-sm cursor-pointer" style={{ color: 'rgba(255,255,255,0.8)' }}>
        <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)}
          className="mt-0.5" data-testid={`social-age-checkbox-${provider}`} />
        <span>{es ? 'Confirmo que tengo 18 años o más.' : 'I confirm I am 18 or older.'}</span>
      </label>
      <div className="flex gap-2 mt-4">
        <button type="button" onClick={onContinue} disabled={!checked} data-testid={`social-age-continue-${provider}`}
          className="flex-1 py-2.5 rounded-lg text-sm font-semibold disabled:opacity-40"
          style={{ backgroundColor: '#E6C06E', color: '#0B0B12' }}>
          {es ? 'Continuar' : 'Continue'}
        </button>
        <button type="button" onClick={onCancel} data-testid={`social-age-cancel-${provider}`}
          className="py-2.5 px-4 rounded-lg text-sm" style={{ color: 'rgba(255,255,255,0.7)' }}>
          {es ? 'Cancelar' : 'Cancel'}
        </button>
      </div>
    </div>
  );
};
